<template>
  <validation-observer ref="SignalGroupsForm" class="form">
    <form ref="form" class="form">
      <b-form-group>
        <b-alert v-if="message.status == 'Error'" show variant="danger">
          <h4 class="alert-heading">{{ errMsg }}</h4>
          <p>{{ errMsg }}</p>
          <hr />
          <p class="mb-0">{{ message.message }}</p>
        </b-alert>
        <validation-provider
          :name="$t('defination.signalGroups.form.code')"
          :rules="{ required: true, max: 3, min: 1 }"
          v-slot="validationContext"
        >
          <b-row>
            <b-col sm="4"> <label for="code"> {{$t('defination.signalGroups.form.code')}} </label> </b-col>
            <b-col sm="8">
              <b-form-input
                id="code"
                v-model="code"
                :placeholder="$t('defination.signalGroups.formPlaceholder.code')"
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
              />
              <b-form-invalid-feedback id="live-feedback">{{
                validationContext.errors[0]
              }}</b-form-invalid-feedback>
            </b-col>
          </b-row>
        </validation-provider>

        <validation-provider
          :name="$t('defination.signalGroups.form.name')"
          :rules="{ required: true, min: 3 }"
          v-slot="validationContext"
        >
          <b-row>
            <b-col sm="4"> <label for="name"> {{$t('defination.signalGroups.form.name')}} </label> </b-col>
            <b-col sm="8">
              <b-form-input
                id="name"
                v-model="name"
                :placeholder="$t('defination.signalGroups.formPlaceholder.name')"
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
              />
              <b-form-invalid-feedback id="live-feedback">{{
                validationContext.errors[0]
              }}</b-form-invalid-feedback>
            </b-col>
          </b-row>
        </validation-provider>

        <b-row>
          <b-col sm="4">
            <label for="restore_id"> {{$t('defination.signalGroups.form.restore')}} </label>
          </b-col>
          <b-col sm="8">
          <Multiselect  
            v-model="restore"
            :show-labels="false" 
            :options="SignalGroups"
            @input="setRestoreId"
            label="name"
            track-by="ID"
            :placeholder="$t('general.select')"
            >
                <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.name }} </strong> 
                </template>
          </Multiselect>
          </b-col>
        </b-row>

        <validation-provider
          :name="$t('defination.signalGroups.form.notify_detail')"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-row>
            <b-col sm="4">
              <label for="notify_detail"> {{$t('defination.signalGroups.form.notify_detail')}} </label>
            </b-col>
            <b-col sm="8">
              <b-form-input
                id="notify_detail"
                v-model="notify_detail"
                :placeholder="$t('defination.signalGroups.formPlaceholder.notify_detail')"
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
              />
              <b-form-invalid-feedback id="live-feedback">{{
                validationContext.errors[0]
              }}</b-form-invalid-feedback>
            </b-col>
          </b-row>
        </validation-provider>
        <b-row>
          <b-col sm="4"> <label> {{$t('defination.signalGroups.form.bulk_process')}} </label> </b-col>
          <b-col sm="8">
            <div class="singleLine">
              <b-form-checkbox v-model="is_bulk_process">
                {{$t('defination.signalGroups.form.is_bulk_process')}}
              </b-form-checkbox>
              <b-form-checkbox v-model="is_auto_postpone">
                {{$t('defination.signalGroups.form.is_auto_postpone')}}
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <label> {{$t('defination.signalGroups.form.signal_process')}} </label>
          </b-col>
          <b-col sm="8">
            <div class="singleLine">
              <b-form-checkbox v-model="is_free_sms">
                {{$t('defination.signalGroups.form.is_free_sms')}}
              </b-form-checkbox>
              <b-form-checkbox v-model="is_auto_process">
                {{$t('defination.signalGroups.form.is_auto_process')}}
              </b-form-checkbox>
              <b-form-checkbox v-model="is_bulk_postpone">
                {{$t('defination.signalGroups.form.is_bulk_postpone')}}
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <label for="auto_postpone_time"> {{$t('defination.signalGroups.form.auto_postpone_time')}} </label>
          </b-col>
          <b-col sm="8">
            <b-form-input
              type="number"
              id="sb-small"
              :placeholder="$t('defination.signalGroups.form.auto_postpone_time')"
              class="mb-2"
              v-model="auto_postpone_time"
            ></b-form-input
          ></b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <label for="file_input">
              {{$t('defination.signalGroups.form.audio_url')}}
              <b>{{ audio_url }}</b></label
            >
          </b-col>
          <b-col sm="8">
            <b-form-file
              ref="file-input"
              class="mb-2 w-100"
              @change="fileChange"
            ></b-form-file
          ></b-col>
        </b-row>
      </b-form-group>
    </form>
  </validation-observer>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
  name: "SignalGroupsForm",
  data: function() {
    return {
      errMsg: "",
      audio_url: this.data ? this.data.audio_url : "", 
      auto_postpone_time: this.data ? this.data.auto_postpone_time : 0, 
      code: this.data ? this.data.code : "", 
      is_auto_postpone: this.data ? this.data.is_auto_postpone : false,
      is_auto_process: this.data ? this.data.is_auto_process : false, 
      is_bulk_postpone: this.data ? this.data.is_bulk_postpone : false, 
      is_bulk_process: this.data ? this.data.is_bulk_process : false, 
      is_free_sms: this.data ? this.data.is_free_sms : false, 
      is_restore: this.data ? this.data.is_restore : false, 
      name: this.data ? this.data.name : "", 
      notify_detail: this.data ? this.data.notify_detail : "", 
      restore_id: this.data ? this.data.restore_id : 0,
      restore: this.data ? this.$store.getters.getSignalGroups.find(item=>item.ID === this.data.restore_id) : null
    };
  },
  props: {
    data: Object,
    changeData: Function,
    save: Boolean,
    saveState: Function,
    modalName: String,
    modalEvent: Function
  },
  components:{
    Multiselect
  },
  methods: {
    setRestoreId(val) {
      if (val) {
        this.is_restore = true;
        this.restore_id=val.ID
      } else {
        this.is_restore = false;
        this.restore_id = 0
      }
    },
    fileChange(e) {
      this.audio_url = e.target.files[0].name;
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    clearForm() {
      this.errMsg = "";
        this.audio_url = "",
        this.auto_postpone_time = 0,
        this.code = "",
        this.is_auto_postpone = false,
        this.is_auto_process = false,
        this.is_bulk_postpone = false,
        this.is_bulk_process = false,
        this.is_free_sms = false,
        this.is_restore = false,
        this.name = "",
        this.notify_detail = "",
        this.restore_id = 0
      this.modalEvent(false);
    }
  },
  computed: {
    message() {
      return this.$store.getters.getStatus;
    },
    SignalGroups() {
      return this.$store.getters.getSignalGroups;
    },
  },
  watch: {
    save: async function(data) {
      if (data) {
        this.$refs.SignalGroupsForm.validate().then(async success => {
          if (success) {
            let val = {
              audio_url: this.audio_url,
              auto_postpone_time: this.auto_postpone_time,
              code: this.code, 
              is_auto_postpone: this.is_auto_postpone,
              is_auto_process: this.is_auto_process, 
              is_bulk_postpone: this.is_bulk_postpone,
              is_bulk_process: this.is_bulk_process, 
              is_free_sms: this.is_free_sms, 
              is_restore: this.is_restore, 
              name: this.name, 
              notify_detail: this.notify_detail, 
              restore_id: this.restore_id, 
            }
            switch (this.modalName) {
              case "add":
                await this.$store.dispatch("addSignalGroups", val);
                break;
              case "edit":
                val.ID = this.data.ID;
                await this.$store.dispatch("editSignalGroups", val);
                break;
            }
            if (this.$store.getters.getAddressStatus.status == "Success") {
              this.$store.dispatch("signal_group_list");
              this.clearForm();
            } else {
              this.errMsg = i18n.t("general.addErrMsg");
            }
          }
        });
      }
      this.saveState(false);
    }
  }
};
</script>

<style lang="css" scoped>
@import "../styles/modalForm.min.css";
@import "../styles/modal.min.css";
</style>



// WEBPACK FOOTER //
// src/pages/General/Defination/modals/SignalGroupsForm.vue